// Constantes et petits utilitaires des QRT, partages par la page, le tableau
// et la fiche (avant : definis dans RFIPage.jsx, valeurs inchangees).

// value = valeur persistee en base (inchangee) ; key = libelle affiche
export const PROFESSIONS = [
  { value: 'Architect', key: 'architect' },
  { value: 'Mechanical', key: 'mechanical' },
  { value: 'Electrical', key: 'electrical' },
  { value: 'Structural', key: 'structural' },
  { value: 'Civil', key: 'civil' },
  { value: 'Plumbing', key: 'plumbing' },
  { value: 'General Contractor', key: 'generalContractor' },
  { value: 'Owner', key: 'owner' },
  { value: 'Other', key: 'other' },
];

// Traduit une profession stockee ; retombe sur la valeur brute si inconnue
export const professionLabel = (t, value) => {
  if (!value) return null;
  const match = PROFESSIONS?.find((p) => p?.value === value);
  return match ? t(`rfi.professions.${match?.key}`) : value;
};

// Couleurs des pastilles de profession (table QRT), meme pattern que
// getCategoryConfig dans ExtrasTable.
export const PROFESSION_COLORS = {
  Architect:            { bg: 'bg-blue-100',    text: 'text-blue-700'    },
  Mechanical:           { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  Electrical:           { bg: 'bg-yellow-100',  text: 'text-yellow-700'  },
  Structural:           { bg: 'bg-purple-100',  text: 'text-purple-700'  },
  Civil:                { bg: 'bg-orange-100',  text: 'text-orange-700'  },
  Plumbing:             { bg: 'bg-cyan-100',    text: 'text-cyan-700'    },
  'General Contractor': { bg: 'bg-gray-100',    text: 'text-gray-600'    },
  Owner:                { bg: 'bg-indigo-100',  text: 'text-indigo-700'  },
  Other:                { bg: 'bg-gray-100',    text: 'text-gray-500'    },
};

export const professionColor = (value) =>
  PROFESSION_COLORS?.[value] || { bg: 'bg-gray-100', text: 'text-gray-500' };

// La couleur de la pastille vient de statusVariant + Badge, plus d'ici.
export const RFI_STATUSES = [
  { value: 'draft', labelKey: 'rfi.status.draft', fallback: 'Créé' },
  { value: 'sent_for_approval', labelKey: 'rfi.status.sent_for_approval', fallback: 'Envoyé pour approbation' },
  { value: 'answered', labelKey: 'rfi.status.answered', fallback: 'Répondu' },
  { value: 'in_review', labelKey: 'rfi.status.in_review', fallback: 'En révision' },
];

export const statusLabel = (t, status) => {
  const cfg = RFI_STATUSES?.find((s) => s?.value === status) || RFI_STATUSES?.[0];
  return t(cfg?.labelKey) || cfg?.fallback;
};

export const formatDate = (iso, language) => {
  if (!iso) return '—';
  return new Date(iso)?.toLocaleDateString(language === 'fr' ? 'fr-CA' : 'en-CA', { year: 'numeric', month: 'short', day: 'numeric' });
};

// Un QRT repondu n'est plus VERROUILLE : sa reponse reste modifiable. Ce test
// ne dit donc plus « bloque », il dit « a une reponse » — il commande
// l'affichage du bloc Reponse, pas l'interdiction d'agir.
// ('closed' retire : la contrainte CHECK ne l'autorise plus depuis 2026-08-06.)
export const isAnswered = (status) => status === 'answered';
